import React from 'react';
import PropTypes from 'prop-types';
import { ToggleLabel, TooltipHelp, ToastContext } from '@weezevent/nacre';
import ExportButton from '../../../../components/export/exportButton';
import { Trans, useTranslation } from 'react-i18next';
import { fetcher } from '@weezevent/weezjs-core';
import Style from '../list.module.css';
import useAppContext from '../../../../context/useAppContext';

export function OrderExportModal({ organization, event, showExportModal, setShowExportModal, filtersQs, ordering, from, selected = [] }) {
    const { t } = useTranslation();

    const baseExportColumns = [
        { target: 'number', value_map: null, header: t('ticket.export.headers.order_number') },
        { target: 'advanced_number', value_map: null, header: t('ticket.export.headers.order_advanced_number') },
        { target: 'id', value_map: null, header: t('ticket.export.headers.id_transaction') },
        { target: 'date', value_map: null, header: t('ticket.export.headers.order_date') },
        { target: 'hour', value_map: null, header: t('ticket.export.headers.order_hour') },
        { target: 'origin', value_map: null, header: t('ticket.export.headers.order_origin') },
        { target: 'locale', value_map: null, header: t('ticket.export.headers.order_locale') },
        { target: 'buyer_first_name', value_map: null, header: t('ticket.export.headers.buyers_first_name') },
        { target: 'buyer_last_name', value_map: null, header: t('ticket.export.headers.buyers_last_name') },
        { target: 'buyer_email', value_map: null, header: t('ticket.export.headers.buyer_email') },
        { target: 'deleted', value_map: null, header: t('ticket.export.headers.order_deleted') },
        { target: 'deletion_date', value_map: null, header: t('ticket.export.headers.deletion_date') },
        { target: 'status', value_map: null, header: t('ticket.export.headers.order_status') },
        { target: 'payment_date', value_map: null, header: t('ticket.export.headers.payment_date') },
        { target: 'payment_time', value_map: null, header: t('ticket.export.headers.payment_time') },
        { target: 'payment_type', value_map: null, header: t('ticket.export.headers.payment_type') },
        { target: 'tickets_number', value_map: null, header: t('ticket.export.headers.ticket_numbers') },
        { target: 'currency', value_map: null, header: t('ticket.export.headers.currency') },
        { target: 'total_buyer', value_map: null, header: t('ticket.export.headers.total_buyer') },
        { target: 'total_fees', value_map: null, header: t('ticket.export.headers.total_fees') },
        { target: 'weezevent_fee', value_map: null, header: t('ticket.export.headers.weezevent_fee') },
        { target: 'discount__code', value_map: null, header: t('ticket.export.headers.discount_code') },
        { target: 'discount_amount', value_map: null, header: t('ticket.export.headers.discount_amount') },
        { target: 'paid_price_ticket', value_map: null, header: t('ticket.export.headers.paid_price_ticket') },
        { target: 'commission_ticket', value_map: null, header: t('ticket.export.headers.commission_ticket') },
        { target: 'paid_price_without_weezevent', value_map: null, header: t('ticket.export.headers.paid_price_without_weezevent') },
        { target: 'paid_price_cross_selling', value_map: null, header: t('ticket.export.headers.paid_price_cross_selling') },
        { target: 'paid_price_cross_selling_ht', value_map: null, header: t('ticket.export.headers.paid_price_cross_selling_ht') },
        { target: 'origin_marketing', value_map: null, header: t('ticket.export.headers.origin') },
        { target: 'invoice_company', value_map: null, header: t('ticket.export.headers.invoice_company') },
        { target: 'invoice_vat_number', value_map: null, header: t('ticket.export.headers.invoice_vat_number') },
        { target: 'invoice_address', value_map: null, header: t('ticket.export.headers.invoice_address') },
        { target: 'invoice_zip_code', value_map: null, header: t('ticket.export.headers.invoice_zip_code') },
        { target: 'invoice_city', value_map: null, header: t('ticket.export.headers.invoice_city') },
        { target: 'invoice_region', value_map: null, header: t('ticket.export.headers.invoice_region') },
        { target: 'invoice_country', value_map: null, header: t('ticket.export.headers.invoice_country') },
        { target: 'invoice_information', value_map: null, header: t('ticket.export.headers.invoice_information') },
        { target: 'origin_detail', value_map: null, header: t('ticket.export.headers.origin_detail') },
        { target: 'refund_request_amount', value_map: null, header: t('ticket.export.headers.refund_request_amount') },
        { target: 'payment_plan_type', value_map: null, header: t('ticket.export.headers.payment_plan_type') },
        { target: 'payment_plan_status', value_map: null, header: t('ticket.export.headers.payment_plan_status') },
        { target: 'payment_plan_number_instalments_completed', value_map: null, header: t('ticket.export.headers.payment_plan_number_instalments_completed') },
        { target: 'payment_plan_number_instalments', value_map: null, header: t('ticket.export.headers.payment_plan_number_instalments') },
        { target: 'payment_plan_paid_amount', value_map: null, header: t('ticket.export.headers.payment_plan_paid_amount') },
        { target: 'payment_plan_total_amount', value_map: null, header: t('ticket.export.headers.payment_plan_total_amount') },
        { target: 'payment_plan_remaining_amount', value_map: null, header: t('ticket.export.headers.payment_plan_remaining_amount') },
        { target: 'payment_plan_last_payment_received_date', value_map: null, header: t('ticket.export.headers.payment_plan_last_payment_received_date') },
        { target: 'payment_plan_next_payment_date', value_map: null, header: t('ticket.export.headers.payment_plan_next_payment_date') }
    ];

    return (
        <GPDExportModal
            organization={organization}
            event={event}
            showExportModal={showExportModal}
            setShowExportModal={setShowExportModal}
            context="orders"
            from={from}
            ordering={ordering}
            filtersQs={filtersQs}
            exportColumns={baseExportColumns}
            selected={selected}
        />
    );
}

export function AttendeeExportModal({ organization, event, showExportModal, setShowExportModal, filtersQs, ordering, from, selected = [] }) {
    const { t } = useTranslation();
    const [{ feature_flags }] = useAppContext();

    const baseExportColumns = [
        { target: 'barcode', value_map: null, header: t('ticket.export.headers.barcode') },
        { target: 'first_name', value_map: null, header: t('ticket.export.headers.attendee_first_name') },
        { target: 'last_name', value_map: null, header: t('ticket.export.headers.attendee_last_name') },
        { target: 'email', value_map: null, header: t('ticket.export.headers.attendee_email') },
        { target: 'company', value_map: null, header: t('ticket.export.headers.company') },
        { target: 'membership_code', value_map: null, header: t('ticket.export.headers.membership_code') },
        { target: 'order_number', value_map: null, header: t('ticket.export.headers.order_number') },
        { target: 'order_advanced_number', value_map: null, header: t('ticket.export.headers.order_advanced_number') },
        { target: 'order_date', value_map: null, header: t('ticket.export.headers.order_date') },
        { target: 'order_hour', value_map: null, header: t('ticket.export.headers.order_hour') },
        { target: 'order_origin', value_map: null, header: t('ticket.export.headers.order_origin') },
        { target: 'order_locale', value_map: null, header: t('ticket.export.headers.order_locale') },
        { target: 'buyer_first_name', value_map: null, header: t('ticket.export.headers.buyers_first_name') },
        { target: 'buyer_last_name', value_map: null, header: t('ticket.export.headers.buyers_last_name') },
        { target: 'buyer_email', value_map: null, header: t('ticket.export.headers.buyer_email') },
        { target: 'rate', value_map: null, header: t('ticket.export.headers.rate') },
        { target: 'rate_group', value_map: null, header: t('ticket.export.headers.rate_group') },
        { target: 'id_weez_ticket', value_map: null, header: t('ticket.export.headers.id_weez_ticket') },
        { target: 'inventory', value_map: null, header: t('ticket.export.headers.inventory') },
        { target: 'access', value_map: null, header: t('ticket.export.headers.access') },
        { target: 'zone', value_map: null, header: t('ticket.export.headers.zone') },
        { target: 'category', value_map: null, header: t('ticket.export.headers.category') },
        { target: 'row', value_map: null, header: t('ticket.export.headers.row') },
        { target: 'seat', value_map: null, header: t('ticket.export.headers.seat') },
        { target: 'session', value_map: null, header: t('ticket.export.headers.session') },
        { target: 'session_year', value_map: null, header: t('ticket.export.headers.session_year') },
        { target: 'session_month', value_map: null, header: t('ticket.export.headers.session_month') },
        { target: 'session_day', value_map: null, header: t('ticket.export.headers.session_day') },
        { target: 'session_time', value_map: null, header: t('ticket.export.headers.session_time') },
        { target: 'deleted', value_map: null, header: t('ticket.export.headers.deleted') },
        { target: 'deletion_date', value_map: null, header: t('ticket.export.headers.deletion_date') },
        { target: 'ticket_status', value_map: null, header: t('ticket.export.headers.ticket_status') },
        { target: 'moderation_status', value_map: null, header: t('ticket.export.headers.moderation_status') },
        { target: 'payment_date', value_map: null, header: t('ticket.export.headers.payment_date') },
        { target: 'payment_time', value_map: null, header: t('ticket.export.headers.payment_time') },
        { target: 'payment_type', value_map: null, header: t('ticket.export.headers.payment_type') },
        { target: 'currency', value_map: null, header: t('ticket.export.headers.currency') },
        { target: 'total_buyer', value_map: null, header: t('ticket.export.headers.total_buyer') },
        { target: 'discount_code', value_map: null, header: t('ticket.export.headers.discount_code') },
        { target: 'discount_amount', value_map: null, header: t('ticket.export.headers.discount_amount') },
        { target: 'paid_price_vat', value_map: null, header: t('ticket.export.headers.paid_price_with_vat') },
        { target: 'paid_price_without_vat', value_map: null, header: t('ticket.export.headers.paid_price_without_vat') },
        { target: 'weezevent_fee', value_map: null, header: t('ticket.export.headers.weezevent_fee') },
        { target: 'paid_price_without_weezevent', value_map: null, header: t('ticket.export.headers.paid_price_without_weezevent') },
        { target: 'vat_rate', value_map: null, header: t('ticket.export.headers.vat_rate') },
        { target: 'vat_amount', value_map: null, header: t('ticket.export.headers.vat_amount') },
        { target: 'origin', value_map: null, header: t('ticket.export.headers.origin') },
        { target: 'partner_name', value_map: null, header: t('ticket.export.headers.partner_name') },
        { target: 'invoice_company', value_map: null, header: t('ticket.export.headers.invoice_company') },
        { target: 'invoice_vat_number', value_map: null, header: t('ticket.export.headers.invoice_vat_number') },
        { target: 'invoice_address', value_map: null, header: t('ticket.export.headers.invoice_address') },
        { target: 'invoice_zip_code', value_map: null, header: t('ticket.export.headers.invoice_zip_code') },
        { target: 'invoice_city', value_map: null, header: t('ticket.export.headers.invoice_city') },
        { target: 'invoice_region', value_map: null, header: t('ticket.export.headers.invoice_region') },
        { target: 'invoice_country', value_map: null, header: t('ticket.export.headers.invoice_country') },
        { target: 'invoice_information', value_map: null, header: t('ticket.export.headers.invoice_information') },
        { target: 'origin_detail', value_map: null, header: t('ticket.export.headers.origin_detail') },
        { target: 'scanned', value_map: null, header: t('ticket.export.headers.scanned') },
        { target: 'scan_date', value_map: null, header: t('ticket.export.headers.scan_date') },
        { target: 'refund_request', value_map: null, header: t('ticket.export.headers.refund_request') },
        { target: 'refund_request_amount', value_map: null, header: t('ticket.export.headers.refund_request_amount') },
        { target: 'refund_request_origin', value_map: null, header: t('ticket.export.headers.refund_request_origin') },
        { target: 'comment', value_map: null, header: t('ticket.export.headers.comment') },
        { target: 'fees_amount_ttc', value_map: null, header: t('ticket.export.headers.fees_amount_ttc') },
        { target: 'fees_amount_ht', value_map: null, header: t('ticket.export.headers.fees_amount_ht') },
        { target: 'resale_status', value_map: null, header: t('ticket.export.headers.resale_status') },
        { target: 'resale_price', value_map: null, header: t('ticket.export.headers.resale_price') },
        { target: 'resale_private', value_map: null, header: t('ticket.export.headers.resale_private') },
        { target: 'resale_new_barcode', value_map: null, header: t('ticket.export.headers.resale_new_barcode') },
        { target: 'resale_created', value_map: null, header: t('ticket.export.headers.resale_created') }
    ];
    const exportColumns = React.useMemo(() => {
        fetcher.get(`/ticket/organizations/${organization.pk}/events/${event.pk}/forms/get_used_form_fields`).then(({ response }) => {
            response['buyer_form_fields'].forEach(({ weez_id, label }) =>
                baseExportColumns.push({ target: `buyer_form_values.${weez_id}`, value_map: null, header: `${t('ticket.common.buyer')} : ${label}` })
            );
            response['attendee_form_fields'].forEach(({ weez_id, label }) =>
                baseExportColumns.push({ target: `form_values.${weez_id}`, value_map: null, header: `${t('ticket.common.attendee')} : ${label}` })
            );
            // add barcode_serial column on export (not handled by FormEntry/FormField)
            if (feature_flags?.includes('EO_CUSTOM_BARCODES'))
                baseExportColumns.push({
                    target: 'form_values.wc-barcode_serial',
                    value_map: null,
                    header: `${t('ticket.common.attendee')} : ${t('ticket.export.headers.barcode_serial')}`
                });
        });
        return baseExportColumns;
    }, [event, organization, feature_flags]);

    return (
        <GPDExportModal
            organization={organization}
            event={event}
            showExportModal={showExportModal}
            setShowExportModal={setShowExportModal}
            context="attendees"
            from={from}
            ordering={ordering}
            filtersQs={filtersQs}
            exportColumns={exportColumns}
            selected={selected}
        />
    );
}

export function ProductExportModal({ organization, event, showExportModal, setShowExportModal }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const [exportAttendees, setExportAttendees] = React.useState(true);
    const [exportBuyers, setExportBuyers] = React.useState(true);

    const baseExportColumns = [
        { target: 'barcode', value_map: null, header: t('ticket.export.headers.barcode') },
        { target: 'variant_product_name', value_map: null, header: t('ticket.export.headers.product_name') },
        { target: 'variant_name', value_map: null, header: t('ticket.export.headers.variant_name') },
        { target: 'variant_reference', value_map: null, header: t('ticket.export.headers.variant_reference') },
        { target: 'attendee_id_weez_ticket', value_map: null, header: t('ticket.export.headers.id_weez_ticket') },
        { target: 'attendee_first_name', value_map: null, header: t('ticket.export.headers.attendee_first_name') },
        { target: 'attendee_last_name', value_map: null, header: t('ticket.export.headers.attendee_last_name') },
        { target: 'attendee_email', value_map: null, header: t('ticket.export.headers.attendee_email') },
        { target: 'order_transaction_reference', value_map: null, header: t('ticket.export.headers.order_number') },
        { target: 'order_id_meta_order', value_map: null, header: t('ticket.export.headers.order_advanced_number') },
        { target: 'order_sold_date', value_map: null, header: t('ticket.export.headers.order_date') },
        { target: 'order_origin', value_map: null, header: t('ticket.export.headers.order_origin') },
        { target: 'order_locale', value_map: null, header: t('ticket.export.headers.order_locale') },
        { target: 'order_buyer_first_name', value_map: null, header: t('ticket.export.headers.buyers_first_name') },
        { target: 'order_buyer_last_name', value_map: null, header: t('ticket.export.headers.buyers_last_name') },
        { target: 'order_buyer_email', value_map: null, header: t('ticket.export.headers.buyer_email') },
        { target: 'deleted', value_map: null, header: t('ticket.export.headers.product_deleted') },
        { target: 'deletion_date', value_map: null, header: t('ticket.export.headers.deletion_date') },
        { target: 'order_status', value_map: null, header: t('ticket.export.headers.product_status') },
        { target: 'order_payment_date', value_map: null, header: t('ticket.export.headers.payment_date') },
        { target: 'order_currency', value_map: null, header: t('ticket.export.headers.currency') },
        { target: 'order_price_ticket', value_map: null, header: t('ticket.export.headers.total_buyer') },
        { target: 'order_discount_code_code', value_map: null, header: t('ticket.export.headers.discount_code') },
        { target: 'attendee_reduction_amount', value_map: null, header: t('ticket.export.headers.discount_amount') },
        { target: 'paid_price', value_map: null, header: t('ticket.export.headers.paid_price') },
        { target: 'paid_price_ht', value_map: null, header: t('ticket.export.headers.paid_price_without_vat') },
        { target: 'vat_product', value_map: null, header: t('ticket.export.headers.vat_rate') },
        { target: 'vat_amount', value_map: null, header: t('ticket.export.headers.vat_amount') },
        { target: 'attendee_fees_amount_ttc', value_map: null, header: t('ticket.export.headers.fees_amount_ttc') },
        { target: 'attendee_fees_amount_ht', value_map: null, header: t('ticket.export.headers.fees_amount_ht') },
        { target: 'origin', value_map: null, header: t('ticket.export.headers.origin') },
        { target: 'order_invoice_company', value_map: null, header: t('ticket.export.headers.invoice_company') },
        { target: 'order_invoice_vat_number', value_map: null, header: t('ticket.export.headers.invoice_vat_number') },
        { target: 'order_invoice_address', value_map: null, header: t('ticket.export.headers.invoice_address') },
        { target: 'order_invoice_zip_code', value_map: null, header: t('ticket.export.headers.invoice_zip_code') },
        { target: 'order_invoice_city', value_map: null, header: t('ticket.export.headers.invoice_city') },
        { target: 'order_invoice_region', value_map: null, header: t('ticket.export.headers.invoice_region') },
        { target: 'order_invoice_country', value_map: null, header: t('ticket.export.headers.invoice_country') },
        { target: 'order_invoice_information', value_map: null, header: t('ticket.export.headers.invoice_information') },
        { target: 'attendee_scanned', value_map: null, header: t('ticket.export.headers.scanned') },
        { target: 'attendee_scan_date', value_map: null, header: t('ticket.export.headers.scan_date') },
        { target: 'refund_request_date_and_time', value_map: null, header: t('ticket.export.headers.refund_request') },
        { target: 'refund_request_amount', value_map: null, header: t('ticket.export.headers.refund_request_amount') },
        { target: 'refund_request_origin', value_map: null, header: t('ticket.export.headers.refund_request_origin') },
        { target: 'attendee_comment', value_map: null, header: t('ticket.export.headers.comment') },
        { target: 'attendee_resale_status', value_map: null, header: t('ticket.export.headers.resale_status') },
        { target: 'attendee_resale_price', value_map: null, header: t('ticket.export.headers.resale_price') },
        { target: 'attendee_resold_to_private', value_map: null, header: t('ticket.export.headers.resale_private') },
        { target: 'attendee_resold_to_new_attendee_barcode', value_map: null, header: t('ticket.export.headers.resale_new_barcode') },
        { target: 'attendee_resold_to_created', value_map: null, header: t('ticket.export.headers.resale_created') }
    ];

    const handleSubmit = React.useCallback(() => {
        let data = { attendees: false, buyers: false };

        // The backend exports both attendees and buyers by default (i.e., when both are false).
        // To control this behavior, we need to invert the logic:
        // - If only attendees are requested, `attendees` should be true (buyers remain false).
        // - If only buyers are requested, `buyers` should be true (attendees remain false).
        // - Both cannot be true at the same time in the request.
        // Note: If both toggles are false, the submit button will be disabled.

        if (exportAttendees && !exportBuyers) {
            data['attendees'] = true;
        }

        if (!exportAttendees && exportBuyers) {
            data['buyers'] = true;
        }

        return data;
    }, [exportAttendees, exportBuyers]);

    // we can not unmount modale cause download action is interrupted and download doesnt work, thats why we need to reset states
    React.useEffect(() => {
        if (!showExportModal) {
            setExportAttendees(true);
            setExportBuyers(true);
        }
    }, [showExportModal]);

    return (
        <ExportButton
            withCustomizableModal
            eventIds={[event.id]}
            open={showExportModal}
            organization={organization}
            onClose={() => setShowExportModal(false)}
            path={`/ticket/organizations/${organization.pk}/events/${event.id}/export/`}
            showButton={false}
            choiceProcess={'product_transaction_excel'}
            onError={() => toast.error(t('ticket.export.download_state_error'))}
            matchingData={baseExportColumns}
            customTitle={t('ticket.manager.products.action.export.title')}
            customSubtitle={t('ticket.manager.products.action.export.subtitle')}
            submitButtonDisabled={!exportAttendees && !exportBuyers}
            onFetchDownload={handleSubmit}
            modalContent={
                <div className={Style['options-title-toggle']}>
                    <ToggleLabel
                        inlinePosition="left"
                        label={
                            <div>
                                <Trans i18nKey={`ticket.manager.products.action.export.exportAttendees.label`} />
                                <TooltipHelp mini triggerOnHover title={t(`ticket.manager.products.action.export.exportAttendees.tooltip`)} />
                            </div>
                        }
                        onChange={() => setExportAttendees(!exportAttendees)}
                        checked={exportAttendees}
                    />
                    <ToggleLabel
                        inlinePosition="left"
                        label={
                            <div>
                                <Trans i18nKey={`ticket.manager.products.action.export.exportBuyers.label`} />
                                <TooltipHelp mini triggerOnHover title={t(`ticket.manager.products.action.export.exportBuyers.tooltip`)} />
                            </div>
                        }
                        onChange={() => setExportBuyers(!exportBuyers)}
                        checked={exportBuyers}
                    />
                </div>
            }
        />
    );
}

export function GPDExportModal({ organization, event, showExportModal, setShowExportModal, context, filtersQs, exportColumns, eventIds, ordering, from, selected = [] }) {
    const { t } = useTranslation();
    const selectedPks = React.useMemo(() => {
        return selected ? Object.keys(selected) : [];
    }, [selected]);

    const disabledExportPkToggle = React.useMemo(() => {
        return !selectedPks.length || (from === 'orderList' && (context === 'attendees' || context === 'attendees_pdf')) || (from === 'attendeeList' && context === 'orders');
    }, [selectedPks, from, context]);

    const [exportFilters, setExportFilters] = React.useState(disabledExportPkToggle);
    const [exportOrdering, setExportOrdering] = React.useState(true);
    const [exportFiltersByPk, setExportFiltersByPk] = React.useState(!disabledExportPkToggle);
    const toast = React.useContext(ToastContext);

    const shouldDisplayOrderingOption = React.useMemo(() => {
        if (from === 'attendeeList' && (context === 'attendees' || context === 'attendees_pdf')) return true;

        if (from === 'orderList' && context === 'orders') return true;
        return false;
    }, [from, context]);

    const queryFilters = React.useMemo(() => {
        if (exportFilters) {
            return filtersQs;
        }
        if (exportFiltersByPk && selectedPks.length) {
            const joinedPks = selectedPks.join(',');
            if (from === 'attendeeList' && (context === 'attendees' || context === 'attendees_pdf')) {
                return `id__in=${joinedPks}`;
            }
            if (from === 'orderList' && context === 'orders') {
                return `id_transaction__in=${joinedPks}`;
            }
        }
    }, [exportFilters, filtersQs, exportFiltersByPk, from, context, selectedPks]);

    // we can not unmount modale cause download action is interrupted and download doesnt work, thats why we need to reset states
    React.useEffect(() => {
        if (!showExportModal) {
            setExportFilters(disabledExportPkToggle);
            setExportOrdering(true);
            setExportFiltersByPk(!disabledExportPkToggle);
        }
    }, [disabledExportPkToggle, showExportModal]);

    return (
        <ExportButton
            withCustomizableModal
            eventIds={eventIds}
            queryFilters={queryFilters}
            queryOrdering={exportOrdering ? ordering : null}
            open={showExportModal}
            organization={organization}
            onClose={() => setShowExportModal(false)}
            path={`/ticket/organizations/${organization.pk}/events/${event.id}/export/`}
            showButton={false}
            choiceProcess={context}
            onError={() => toast.error(t('ticket.export.download_state_error'))}
            matchingData={exportColumns}
            customTitle={t(`ticket.manager.${context}.action.export.title`)}
            customSubtitle={t(`ticket.manager.${context}.action.export.subtitle`)}
            modalContent={
                <div className={Style['options-title-toggle']}>
                    <ToggleLabel
                        inlinePosition="left"
                        label={
                            <div>
                                <Trans i18nKey={`ticket.manager.${context}.action.export.label`} />
                                <TooltipHelp mini triggerOnHover title={t(`ticket.manager.${context}.action.export.tooltip`)} />
                            </div>
                        }
                        onChange={(e, { checked }) => {
                            setExportFilters(checked);
                            if (checked) {
                                setExportFiltersByPk(false);
                            }
                        }}
                        checked={exportFilters}
                    />
                    <ToggleLabel
                        disabled={disabledExportPkToggle}
                        inlinePosition="left"
                        label={
                            <div>
                                <Trans i18nKey={`ticket.manager.${context}.action.exportPk.label`} />
                                <TooltipHelp mini triggerOnHover title={t(`ticket.manager.${context}.action.exportPk.tooltip`)} />
                            </div>
                        }
                        onChange={(e, { checked }) => {
                            setExportFiltersByPk(checked);
                            if (checked) {
                                setExportFilters(false);
                            }
                        }}
                        checked={exportFiltersByPk}
                    />
                    {shouldDisplayOrderingOption && (
                        <ToggleLabel
                            inlinePosition="left"
                            label={
                                <div>
                                    <Trans i18nKey={`ticket.manager.${context}.action.export.sort`} />
                                    <TooltipHelp mini triggerOnHover title={t(`ticket.manager.${context}.action.export.tooltip_sort`)} />
                                </div>
                            }
                            onChange={() => setExportOrdering(currentState => !currentState)}
                            checked={exportOrdering}
                        />
                    )}
                </div>
            }
        />
    );
}

GPDExportModal.propTypes = {
    event: PropTypes.object.isRequired,
    active: PropTypes.bool,
    eventIds: PropTypes.array
};

GPDExportModal.defaultProps = {
    eventIds: []
};
